
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Getter, Mutation, Action } from "vuex-class";
import { mapState } from "vuex";
import appConfig from "@/appconfig";
@Component({
  components: {}
})
export default class Header extends Vue {
  @Getter("fullname") fullname: any;

  logout() {
    location.replace(appConfig.loginurl + "/logout");
  }
}
